import { gql } from '@apollo/client'

const CREATE_ATTACHMENT = gql`
  mutation CreateAttachment(
    $filename: String!
    $format: String
    $goalId: Int!
    $publicId: String!
    $secureUrl: String!
    $resourceType: String
  ) {
    createAttachment(
      filename: $filename
      format: $format
      goalId: $goalId
      publicId: $publicId
      secureUrl: $secureUrl
      resourceType: $resourceType
    ) {
      id
      createdAt
      filename
      format
      secureUrl
      publicId
      resourceType
    }
  }
`

export default CREATE_ATTACHMENT
